export default "__VITE_ASSET__f13f65b3__"